module.exports = __webpack_public_path__ + "static/img/7-2.af7a359.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/7-2.jpg
// module id = cIHo
// module chunks = 0